import { lazy, Suspense } from "react";
import { Switch, Route } from "react-router-dom";
import Footer from "../components/Footer";
import Header from "../components/Header";
import routes from "./config";
import { LangWrapper } from "./LangWrapper";
import { Styles } from "../styles/styles";

const Home = lazy(() => import("../pages/Home"));

const Router = () => {
  return (
    <Suspense fallback={null}>
      <Styles />
      <Header />
      <Switch>
        {/* URL-based language: /en or /eng = English, /es or /spanish = Spanish */}
        <Route path="/en" exact>
          <LangWrapper lang="en">
            <Home />
          </LangWrapper>
        </Route>
        <Route path="/eng" exact>
          <LangWrapper lang="en">
            <Home />
          </LangWrapper>
        </Route>
        <Route path="/es" exact>
          <LangWrapper lang="es">
            <Home />
          </LangWrapper>
        </Route>
        <Route path="/spanish" exact>
          <LangWrapper lang="es">
            <Home />
          </LangWrapper>
        </Route>
        {routes.map((routeItem) => {
          return (
            <Route
              key={routeItem.component}
              path={routeItem.path}
              exact={routeItem.exact}
              component={lazy(() => import(`../pages/${routeItem.component}`))}
            />
          );
        })}
      </Switch>
      <Footer />
    </Suspense>
  );
};

export default Router;
